const CHUNK_RELOAD_KEY = "tt-chunk-reload-at";
const CHUNK_RELOAD_COOLDOWN_MS = 10_000;

/**
 * After a deploy, an open tab still requests the previous hashed chunk.
 * Reload once so the new index.html supplies the new filename. A second
 * failure inside the cooldown falls through to the existing error screen.
 */
export function registerChunkReloadOnPreloadError(): void {
  window.addEventListener("vite:preloadError", (event) => {
    let lastReloadAt = 0;
    try {
      lastReloadAt = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) ?? 0);
    } catch {
      return;
    }

    if (Date.now() - lastReloadAt < CHUNK_RELOAD_COOLDOWN_MS) {
      return;
    }

    try {
      sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
    } catch {
      return;
    }

    event.preventDefault();
    window.location.reload();
  });
}
